export const VOD_CONTENT_STATE_STATUSES = {
  EMPTY: 'EMPTY',
  PENDING: 'PENDING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

/**
 * A SERIES has 1 (or +) Seasons. A Season has 1 (or +) EPISODE
 * @type {{SERIES: string, EPISODE: string, MOVIES: string}}
 */
export const VOD_CONTENT_TYPE = {
  SERIES: 'series',
  EPISODE: 'episode',
  MOVIES: 'movie',
};

export const ITEMS_PER_PAGE = 10000;
export const CATAGORIES_PER_PAGE = 100;
